import { lazy, memo, useState } from "react";
import HeaderDesktop from "@Components/Header/HeaderDesktop";
import { PAGE } from "constants/index";

import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import SectionRegionInfo from "../components/SectionRegionInfo";
import FilterSection from "../components/FilterSection/FilterSection";
import SearchFeaturedBlogs from "../components/SearchFeaturedBlogs/SearchFeaturedBlogs";
import FooterDesktop from "@Components/FooterV2/FooterDesktop";
import LeadFormModalWithWrapper from "@Components/LeadFormModal";

import styles from "./SearchDesktopV2.module.scss";
import ZendeskChat from "@Pages/PropertyPage/components/ZendeskChat";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import HeaderCustomLinksDesktop from "@Components/HeaderCustomLinks/HeaderCustomLinksDesktop/HeaderCustomLinksDesktop";
import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import SearchListContainer from "../components/SearchListContainer/SearchListContainer";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";
import useFilterHistory from "../hooks/useFilterHistory";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";

const RecentelyViewedSection = lazy(
  () => import("@Pages/Search/components/RecentelyViewedSection/RecentelyViewedSection"),
);

const FooterDesktopWhiteLabel = loadable(
  () => import("@Components/FooterWhiteLabel/FooterDesktopWhiteLabel"),
  {
    fallback: <FullPageLoader height="284px" />,
  },
);

const AgentViewSideBar = loadable(() => import("../components/AgentViewSideBar"), {
  fallback: <div style={{ width: "24px", minHeight: "100%" }} />,
});

const SearchDesktop = ({ isAgentView = false }) => {
  const { isWhitelabel, whitelabelConfig } = useWhitelabel();
  const [isMapOpen, setIsMapOpen] = useState(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const localityParam = params.get("locality");
      // Check if locality includes "near-by" to match the region name pattern
      return localityParam ? localityParam.includes("near-by") : false;
    }
    return false;
  });
  const { isAbove } = useResponsiveness();
  useFilterHistory();

  return (
    <div className={styles.searchDesktopContainer}>
      <HeaderDesktop parentPage={PAGE.SEARCH} />
      {isWhitelabel && whitelabelConfig?.is_custom_link_enabled && <HeaderCustomLinksDesktop />}
      <FilterSection isDesktop={isAbove(SCREEN_SIZE.MD)} />
      <div className={styles.innerRootContainer}>
        <div className={styles.flexContainer}>
          {isAgentView && <AgentViewSideBar />}
          <SearchListContainer
            handleOnMapOpen={(isOpen: boolean) => setIsMapOpen(isOpen)}
            showMap={isMapOpen}
            isAgentView={isAgentView}
          />
        </div>
        {!isMapOpen && (
          <div className={styles.rootContainer}>
            <LazyLoadOnScroll fallback={<section style={{ height: "700px" }} />}>
              <RecentelyViewedSection isSearchPage gtagEventCategory={PAGE.SEARCH} isDesktop />
            </LazyLoadOnScroll>
            <SectionRegionInfo
              isSearchPage
              includeFields={["links", "description", "faqs"]}
              isDesktop
            />
            <SearchFeaturedBlogs />
          </div>
        )}
      </div>
      <LeadFormModalWithWrapper />
      {!isMapOpen && (
        <>
          {isWhitelabel ? <FooterDesktopWhiteLabel /> : <FooterDesktop />}
          {!isWhitelabel && <ZendeskChat />}
          <AmberCopilotWrapper />
        </>
      )}
    </div>
  );
};

export default wrapperHOC(memo(SearchDesktop), {
  componentName: "SearchPageDesktop",
  showForChina: true,
});
